import VectorSource from '../../node_modules/ol/source/Vector.js';

function numberFormatter(num) {
  if (num === '-') {
    return '-';
  }
  const formatter = Intl.NumberFormat('en', {
    notation: 'compact'
  });
  return formatter.format(num);
}
function vector(options) {
  return new VectorSource({
    features: options.features
  });
}

export { numberFormatter, vector };
//# sourceMappingURL=helpers.js.map
